import type { DailyUsageStat } from '@command-room/shared';
import { formatEur } from '@/lib/format';

const BAR_HEIGHT = 56;

export function DailyChart({ days }: { days: DailyUsageStat[] }) {
  const maxCost = Math.max(...days.map((d) => d.cost_eur), 0.000001);

  return (
    <div className="flex items-end gap-0.5 overflow-x-auto pb-1" style={{ height: BAR_HEIGHT + 24 }}>
      {days.map((d) => {
        const h = Math.max(2, Math.round((d.cost_eur / maxCost) * BAR_HEIGHT));
        const label = d.day.slice(5); // MM-DD
        return (
          <div key={d.day} className="group relative flex flex-1 flex-col items-center gap-0.5" style={{ minWidth: 12 }}>
            <div
              className="w-full rounded-t bg-primary/60 transition-colors group-hover:bg-primary"
              style={{ height: h }}
              title={`${d.day}: ${formatEur(d.cost_eur)} · ${d.runs} runs`}
            />
            <span className="hidden text-[9px] text-muted-foreground group-hover:block">{label}</span>
          </div>
        );
      })}
    </div>
  );
}
